
import { useQuery } from '@tanstack/react-query';
import { loadCategories, getTutorialsByCategory } from '@/utils/markdown-loader';
import { categories as staticCategories, getTutorialsByCategory as getStaticTutorialsByCategory } from '@/utils/sample-data';

export function useCategories() {
  return useQuery({
    queryKey: ['categories'],
    queryFn: async () => {
      try {
        const categoriesData = await loadCategories();
        return categoriesData?.categories || staticCategories;
      } catch (error) {
        console.error('Error fetching categories:', error);
        // Fall back to static data
        return staticCategories;
      }
    }
  });
}

export function useCategoryTutorials(categoryId: string | undefined) {
  return useQuery({
    queryKey: ['category-tutorials', categoryId],
    queryFn: async () => {
      if (!categoryId) return [];
      
      try {
        const tutorials = await getTutorialsByCategory(categoryId);
        return tutorials.length > 0 ? tutorials : getStaticTutorialsByCategory(categoryId);
      } catch (error) {
        console.error(`Error fetching tutorials for category ${categoryId}:`, error);
        // Fall back to static data
        return getStaticTutorialsByCategory(categoryId);
      }
    },
    enabled: !!categoryId,
  });
}
